module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-18.9dfbd0b9.png";